import { css } from "@emotion/css"

import NumberField from "@p-ban/common/src/components/form/NumberField/NumberField"
import Spacer from "@p-ban/common/src/components/layout/Spacer"
import useDebounce from "@p-ban/common/src/hooks/useDebounce"

import FIELD_NAMES from "../../../../../constant/fieldNames"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import HELP_LINKS from "../../../../constant/helpLinks"

import image from "./size.png"

const 外形寸法 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const onUpdateValueX = useDebounce(handlers.number)
  const onUpdateValueY = useDebounce(handlers.number)

  return (
    <OneClickField legend="外形寸法" helpURL={HELP_LINKS.外形寸法} src={image}>
      <label>
        <NumberField
          className={style}
          name={FIELD_NAMES.外形寸法x}
          value={values.sizeX}
          onUpdateValue={onUpdateValueX}
          min={0.1}
          max={9999.9}
          step={0.1}
          maxDecimalDigits={1}
          placeholder="小数第一位まで"
          error={!!errors?.sizeX}
          prefix="X="
          suffix="mm"
        />
      </label>
      <OneClickFieldMessages error={errors?.sizeX} />
      <Spacer size={10} />
      <label>
        <NumberField
          className={style}
          name={FIELD_NAMES.外形寸法y}
          value={values.sizeY}
          onUpdateValue={onUpdateValueY}
          min={0.1}
          max={9999.9}
          step={0.1}
          maxDecimalDigits={1}
          placeholder="小数第一位まで"
          error={!!errors?.sizeY}
          prefix="Y="
          suffix="mm"
        />
      </label>
      <OneClickFieldMessages error={errors?.sizeY} />
    </OneClickField>
  )
}

export default 外形寸法

const style = css`
  width: 120px;
`
